import React from "react";

const PageSidebarContainer = ({ mode, children }) => {
  return (
    <div className="pageSidebarContainer bg-light-1 dark:bg-dark-1 flex flex-col xl:flex-row">
        {children}
    </div>
  );
};

export default PageSidebarContainer;
